// Conventions:
//   - Route permissions (URL paths the user can navigate to) — leading `/` and
//     trailing `/*`, e.g. `/system/*`, `/company/parts/*`.
//   - ACL action permissions (BE `can()` checks) — no leading `/`. Most use a
//     trailing `/*` (e.g. `access-new-order/*`, `quote/omit-default-sales-location/*`),
//     but the suffix is per-resource: BE serializes whatever string is granted to
//     the rank into `user.resources` and the FE checks it via literal
//     `Array.includes(...)` (no wildcard expansion). Pin the enum value to what
//     BE actually emits, not to the BE `can()` argument.
//     Exception: `PARTS_MEDIA_DELETE_IMAGE` and `PARTS_EDIT_SAVE_PARTICULARS` are
//     granted as literal exact strings with no wildcard.
export enum AccessPermissions {
  ACCESS_COMPANY_BOM_DETAILS_EDIT = 'access-company-bom-details-edit/*',
  ACCESS_COMPANY_BOM_DETAILS_VIEW = 'access-company-bom-details-view/*',
  ACCESS_COMPANY_BOM_LOG = 'access-company-bom-log/*',
  ACCESS_COMPANY_DEFAULT_VENDOR_EDIT = 'access-company-default-vendor-edit/*',
  ACCESS_COMPANY_VENDOR_QUOTE_EDIT = 'access-company-vendor-quote-edit/*',
  ACCESS_CONTACT_GROUP_MERGE = 'access-contact-group-merge/*',
  ACCESS_EDIT_EXTRACTOR_VENDOR_MAPPING = 'access-edit-extractor-vendor-mapping/*',
  ACCESS_NEW_ORDER = 'access-new-order/*',
  ACCESS_PART_FINDER = 'access-part-finder/*',
  ACCESS_PART_FINDER_SETUP = 'access-part-finder-setup/*',
  ACCESS_PRICING_PROFILE_ALLOW_ALL_ACCESS = 'access-pricing-profile-allow-all-access/*',
  ALLOW_ALL_CUSTOMERS_ALL_LOCATIONS_SPA = 'access-allow-all-customers-all-locations-spa/*',
  ALLOW_ALL_CUSTOMERS_SPA = 'access-allow-all-customers-spa/*',
  ALLOW_LIVE_OR_PLANNING_SPA = 'access-allow-live-or-planning-spa/*',
  ALLOW_PROGRAM_SPA = 'access-allow-program-spa/*',
  COMPANY_PARTS = '/company/parts/*',
  COMPANY_SETTINGS = '/company/settings/*',
  CORPORATE_PARTS = '/corporate/parts/*',
  IMPORT_VENDOR_QUOTE = 'import-vendor-quote/*',
  JOB_LOG = '/job/log/*',
  PARTS_EDIT_SAVE_PARTICULARS = 'parts/edit/save-particulars',
  PARTS_MEDIA_DELETE_IMAGE = 'parts/media/delete-image',
  QUOTE_OMIT_DEFAULT_SALES_LOCATION = 'quote/omit-default-sales-location/*',
  SELECTABLE_SPA = 'access-enable-selectable-spa/*',
  SEND_AS_SPA = 'access-send-as-spa/*',
  SEND_TO_FILENET = 'access-send-to-filenet/*',
  SUPPORT_REPORT = '/support/report/*',
  SUPPORT_REQUEST = '/support/request/*',
  SUPPORT_REQUEST_HOMEPAGE = '/support/request/homepage',
  SUPPORT_REQUEST_LIST = '/support/request/list',
  SWITCH_USER_VERSION = 'special-access-alternate-user/*',
  SWITCH_VERSION = 'access-new-version/*',
  SYSTEM_SETTINGS = '/system/*',
}

export enum TriggerActions {
  SIGN_IN = 'login',
}
